var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#F0F6FF",
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A75FF",
    strokeLinejoin: "round",
    d: "m16.353 6 1.525 4.122L22 11.647l-4.122 1.525-1.525 4.122-1.525-4.122-4.122-1.525 4.122-1.525L16.353 6Zm-7.059 9.412 1.332 1.961 1.962 1.333-1.961 1.332L9.293 22l-1.332-1.962L6 18.706l1.962-1.332 1.332-1.962Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartFinal);
export default __webpack_public_path__ + "static/media/start-final.a6fa692e9dd90f81366946dd8944e5b2.svg";
export { ForwardRef as ReactComponent };